import React, { Component } from 'react';


import { connect } from 'react-redux';
import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS } = helpers;

import { openModal } from 'actions/modal';

import ClassroomPanelList from 'components/ClassroomPanelList/ClassroomPanelList';

import Input from './Input';
import Button from './Button';

import { keyedObjToArr } from '../util';

class SchoolListPanel extends Component{

	constructor(props) {
		super(props);
		this.state = {
			school : {}
		};
	}

    removeClassroomsAndTeachersForSchool (school) {
        const { firebase } = this.props;
        keyedObjToArr(school.classrooms).forEach( (classroom) => {
			firebase.remove(`/classrooms/${classroom.id}`);

            keyedObjToArr(this.props.users).forEach( (user) => {
                if(user.classrooms && user.classrooms[classroom.id]){
                    firebase.remove(`/users/${user.id}/classrooms/${classroom.id}`);
                }
            });
        });
    }

    updateCustomerSchools (customer, schoolId){
		const { firebase } = this.props;
		let customerSchoolIds = customer.schools;
		customerSchoolIds[schoolId] = true;
		firebase.set(`customers/${customer.id}/schools`, customerSchoolIds);
	}

	addSchool() {
		const { firebase } = this.props;
		let school = this.state.school;

		this.setState({
			school : {}
		});

		if(!school.name){
			return;
		}

		firebase.push('/schools', school).then( (response)=> {
			this.updateCustomerSchools(this.props.customer, response.key);
		});
	}

	deleteSchool (school) {

		this.props.openModal(null, {
			message : 'Are you sure you want to delete this School?\n(this will delete all classrooms in this school)',
			title : 'Delete School',
				onClose : (result) => {
					if(result === true) {
						const { firebase } = this.props;
						firebase.remove(`/schools/${school.id}`);
						firebase.remove(`/customers/${this.props.customer.id}/schools/${school.id}`);
                        this.removeClassroomsAndTeachersForSchool(school);
						//Delete classrooms that belong to this school
						//Delete classrooms that belong tot his school from teachers
					}
				}
			});
	}

	setSchoolName (event) {
		let school = this.state.school;
		school.name = event.target.value;
		school.customer = this.props.customer.id;
		this.setState({
			school : school
		});
	}


	render (){

		if(!isLoaded(this.props.schools)) {
			return false;
		}

		let customerSchools = this.props.customer.schools ? Object.keys(this.props.customer.schools).map( (id)=> {
			let school = this.props.schools[id];
			if(school) {
				school.id = id;
			}
			return school;
		}) : [];

		return (
			<div>
				{customerSchools.map( (school, index)=> {
					return(school ? (
							<ClassroomPanelList
								school={school}
								key={index}
								editing="true"
								customer={this.props.customer}
								products={this.props.products}
								deleteSchool={this.deleteSchool.bind(this)}
							/>
						) : false
					);
				})}
				<form className="flex-grid tight">
					<div className="col grow">
						<Input
							placeholder="School Name"
							onChange={this.setSchoolName.bind(this)}
							value={this.state.school.name}
						/>
					</div>
					<div className="col no-grow">
						<Button
							label="Create School"
							disabled={!this.state.school.name}
							onClick={this.addSchool.bind(this)}
						/>
					</div>
				</form>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openModal : (modal, props) => { dispatch(openModal(modal, props)); }
	};
};

const fbWrappedComponent = firebaseConnect([
	//`schools#orderByChild=customer&equalTo=${this.props.customer.id}`,
	'/schools',
])(SchoolListPanel);

export default connect(
	({ firebase }) => ({
		schools: dataToJS(firebase, 'schools')
	}),
	mapDispatchToProps
)(fbWrappedComponent);





// WEBPACK FOOTER //
// ./js/components/SchoolListPanel.js